var AuthorizedRoute = require('../mixins/authorized-route')
var Scope = require('../utils/scope')

module.exports = Em.Route.extend(AuthorizedRoute, {
    scopes: [Scope.OfferWrite],

    model: function() {
        return this.modelFor('quote')
    },

    afterModel: function(quote) {
        if (quote && !quote.get('isEditable')) {
            this.replaceWith('quote', quote)
        }
    }
})
